module.exports = __webpack_public_path__ + "static/media/YB5F07_4.b729c784.jpg";